module.exports = __webpack_public_path__ + "img/3.dfadd8b9.webp";